import { render, staticRenderFns } from "./FaqComponent.vue?vue&type=template&id=728490f4&scoped=true"
import script from "./FaqComponent.vue?vue&type=script&lang=js"
export * from "./FaqComponent.vue?vue&type=script&lang=js"
import style0 from "./FaqComponent.vue?vue&type=style&index=0&id=728490f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728490f4",
  null
  
)

export default component.exports